export const BADGE_MODELS = [
  'new',
  'seasonal',
  'exclusive',
  'trending',
  'bestseller',
  'custom',
  'guaranteed',
  'top rated',
  'popular',
  'installed'
];

export const INSPIRATIONAL_BADGE_MODELS = [
  'new',
  'trending',
  'bestseller',
  'exclusive'
];

export const EXPERIENCE_TAGS = {
  GIFT_CARD: 'GIFT_CARD'
};

export const BADGE_MESSAGE = {
  GIFT_CARD: 'Gift Card with Purchase'
};

export const BADGE_BACKGROUND_COLORS = {
  GIFT_CARD: '#E0F8ED'
};

export const BADGE_TEXT_COLORS = {
  GIFT_CARD: 'black'
};

export const FEATURE_SWITCHES = {
  ENABLE_GIFT_CARD_PROMOTIONS: 'enableGiftCardPromotions'
};

export const MAX_BADGE_DISPLAY_COUNT_MOBILE = 4;

/** Wrapper ids the fusion layout accordion stamps on each collapsible section. */
export const ACCORDION_SECTION_IDS = {
  overview: 'product-section-overview',
  specs: 'product-section-key-feat',
  qa: 'product-section-qa',
  reviews: 'product-section-rr'
};

/** `?openSection=` takes a key of ACCORDION_SECTION_IDS or a wrapper id. */
export const SECTION_DEEP_LINK_PARAM = 'openSection';

/** Deep links already in the wild, kept pointing at the section they were built for. */
export const SECTION_DEEP_LINK_ALIASES = {
  writeReview: 'reviews',
  writeAReviewOpen: 'reviews'
};

/** Published once per page load when the URL deep links to a section. */
export const SECTION_DEEP_LINK_EVENT = 'product-details.deep-link';

/** Published by the fusion layout accordion with its wrapper ids and expand handle. */
export const ACCORDION_MOUNT_EVENT = 'accordion.mount';
